import { filter, interval, map, take } from "rxjs";

class WindowPopupManager {
    private popup: WindowProxy | null = null;

    open(url: string, target?: string) {
        this.popup = window.open(
            url,
            target,
            "width=800,height=600,menubar=no,location=no,resizable=yes,scrollbars=no,status=no"
        );
    }

    selectClosedPopup() {
        return interval(1000).pipe(
            map(() => this.popup?.closed),
            filter((value): value is boolean => !!value),
            take(1)
        );
    }
}

export default WindowPopupManager;
